import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImagesSparkle"><Path d="M12.5 4.5H4.5V14.2646L8.01562 10.9551L12 14.9395L14 12.9395L19.5 18.4395V11.5H21V21H3V3H12.5V4.5Z" fill="currentColor"/><Path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImagesSparkle;
